var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VerticalContainer',{staticClass:"text-center",scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('Button',{attrs:{"text":"Return home","on-click":_vm.goHome,"is-loading":_vm.isLoading}})]},proxy:true}])},[_c('div',[_c('div',{staticClass:"not-found-title"},[_vm._v(" Not found ")]),_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }